import React from 'react';
import styled from 'styled-components';
import { style } from '../../api';

import { Play } from './Icons';
import { TextRegular12 } from './Text';
import { useIsDesktop } from '../../style/constants';

export default styled(
  ({
    plays,
    className,
    color = style.grey_main_new,
  }: {
    plays: number;
    className?: string;
    color?: string;
  }) => {
    const isDesktop = useIsDesktop();
    return (
      <Plays className={className} color={color}>
        <Play color={color} size={isDesktop ? 16 : 14} />
        {plays}
      </Plays>
    );
  },
)``;

const Plays = styled(TextRegular12)<{ color: string }>`
  display: flex;
  align-items: center;
  height: 16px;
  color: ${(p) => p.color};
  svg {
    margin-left: -3px;
    margin-right: 3px;
  }
`;
